var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.state === 'init' || _vm.state === 'load')?_c('BasePagePreloader'):_c('p',[_vm._v(" Redirecting... ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }